import React from 'react';
import { Autocomplete, TextField, Typography } from '@mui/material';

// Picker for a closed list of types (pattern_types / category_types), grouped by family.
// Mapping a raw value never creates a type: the AI can only suggest listed types, and a
// typed-in name used to become a second name for an existing one ("small checkered"
// next to "checkered", Daniel 2026-10-21). Nothing fits → the admin adds a type on the
// types tab first, on purpose.
//
// options: [{ value, family }], value: the selected value string or null.
export default function TypePicker({ options, value, onChange, label, loading, typesTabName }) {
  const sorted = [...options].sort((a, b) =>
    (a.family || '').localeCompare(b.family || '') || a.value.localeCompare(b.value)
  );
  const selected = sorted.find(o => o.value === value) || null;
  return (
    <Autocomplete
      options={sorted}
      value={selected}
      onChange={(_e, opt) => onChange(opt ? opt.value : null)}
      groupBy={(o) => o.family || '(no family)'}
      getOptionLabel={(o) => o.value}
      isOptionEqualToValue={(a, b) => a.value === b.value}
      loading={loading}
      autoHighlight
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          helperText={
            <Typography variant="caption" component="span">
              Closed list: the AI can only choose from these. Nothing fits? Add the type on the
              “{typesTabName}” tab first, then map.
            </Typography>
          }
        />
      )}
    />
  );
}
